module.exports = __webpack_public_path__ + "static/media/icon-close-mini.22152e1e.svg";